import * as React from 'react'

import { Box, Icon, Text, useToggle } from '@factorialco/deprecated-design-system'

interface EventProps {
  data: Record<string, any>
}
interface NodeProps {
  title: string
  value: Record<string, any>
}

const reformData = (data: unknown[]): { previous: unknown; current: unknown } => {
  return {
    previous: data[0],
    current: data[1],
  }
}

const Parent = ({ title, value }: NodeProps) => {
  const [open, toggle] = useToggle(true)
  const direction = open ? 'down' : 'right'

  return (
    <Box>
      <Box flexDirection="row">
        <Box onClick={toggle(!open)}>
          <Icon.Small icon={`caret-${direction}`} />
        </Box>
        <Text.Normal weight="bold" size="200">
          {title}
        </Text.Normal>
      </Box>
      <Box paddingLeft="s6">
        {open && (
          <Box
            paddingLeft="s40"
            border={{
              left: {
                color: 'grey400',
                style: 'solid',
                width: 's1',
              },
            }}
          >
            <EventData data={value} />
          </Box>
        )}
      </Box>
    </Box>
  )
}

const Child = ({ title, value }: NodeProps) => {
  return (
    <Box flexDirection="row">
      <Text.Normal weight="bold" size="200">
        {title}
      </Text.Normal>
      <Text.Normal size="200">
        <>: {value}</>
      </Text.Normal>
    </Box>
  )
}

const EventData = ({ data }: EventProps) => {
  const eventData: Record<string, unknown> = Array.isArray(data) ? reformData(data) : data
  // reforming data when it is an array is basically for the `changes` key values
  // for now, we're adapting it for all array represented data until we
  // get the needed templates for other keys with values in array form.
  const dataKeys = Object.keys(eventData)

  return (
    <>
      {dataKeys.map((key) => {
        const keyValue = eventData[key]
        const valueType = typeof keyValue

        if (valueType === 'object' && keyValue != null) {
          return <Parent key={key} title={key} value={keyValue} />
        } else {
          return keyValue && <Child key={key} title={key} value={keyValue} />
        }
      })}
    </>
  )
}

export default EventData
